var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FileInput',{attrs:{"accept":"image"},on:{"change":_vm.onupload}},[_vm._t("default")],2),(_vm.logo)?_c('img',{attrs:{"src":_vm.logo}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }